import { Gender } from '@shared/constants/constants';

import type { ChildrenState } from '../types/children.types';

export const initialState: ChildrenState = {
  selectedChild: {
    ageInMonths: 0,
    dob: '',
    gender: Gender.MALE,
  },
};
